import { Turbo } from "@hotwired/turbo-rails"
import { formatApiErrorDetail } from "./api_errore"

// Una scrittura del passo 3 (api.post/put dell'originale) che risponde con un turbo-stream: JSON con la sessione e il
// token CSRF. Risolve con { ok, status, testo, headers } quando la risposta è un turbo-stream (il chiamante lo rende);
// altrimenti l'ha già gestita e risolve con null: un rinvio (sessione scaduta → accesso, verifica in due passaggi) apre
// la pagina a cui rimanda; una risposta JSON mostra il suo `detail` (formatApiErrorDetail); il resto, o una rete che
// non risponde, il testo `errore`.
export async function richiestaStream(url, { method = "POST", corpo, errore = "Non riuscito" } = {}) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  let risposta
  try {
    risposta = await fetch(url, {
      method, credentials: "same-origin", body: corpo === undefined ? undefined : JSON.stringify(corpo),
      headers: { Accept: "text/vnd.turbo-stream.html", "Content-Type": "application/json", ...(token ? { "X-CSRF-Token": token } : {}) },
    })
  } catch {
    window.toast?.error?.(errore)
    return null
  }
  if (risposta.redirected) {
    Turbo.visit(risposta.url)
    return null
  }
  const tipo = risposta.headers.get("Content-Type") || ""
  if (tipo.includes("turbo-stream")) return { ok: risposta.ok, status: risposta.status, testo: await risposta.text(), headers: risposta.headers }
  let detail
  if (tipo.includes("json")) {
    try { detail = (await risposta.json())?.detail } catch { detail = undefined }
  }
  window.toast?.error?.(detail !== undefined && detail !== null ? formatApiErrorDetail(detail) : errore)
  return null
}
